import React from 'react';

export function CopyrightInfo() {
  return <span>&copy; Softek Solutions, Inc {new Date().getFullYear()}</span>;
}
